// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2746":"37689548","3377":"fb43a6a5","5219":"4eb7aa62","7348":"b9975b8f","7387":"39655b8f"}[chunkId] + ".chunk.css";
};